// Adding Node.isConnected support into IE11 and Edge
(function (supported){
    if (supported) return;
    Object.defineProperty(window.Node.prototype, 'isConnected', {
        configurable: false,
        enumerable: true,
        get: function () {
            // Edge and later
            if (document.contains) return document.contains(this);
            // IE11
            return document.body.contains(this);
        }
  })
})('isConnected' in window.Node.prototype);
